export default __webpack_public_path__ + "static/slide1-effe853586fbb3e02b3127918bf7da55.jpg";